import {Component, Inject, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {Equipement} from 'app/models/equipement.model';
import {Piece} from '../../../../models/piece.model';
import {User} from '../../../../models/user.model';
import {EquipementService} from '../../../../services/equipement.service';
import {UserService} from '../../../../services/user.service';
import {PieceEquipement} from '../../../../models/pieceEquipement.model';
import {DossierInterventionService} from '../../../../services/dossier_intervention.service';

@Component({
    selector: 'app-modal-dossier-equipement-add',
    templateUrl: './modal-dossier-equipement.component.html'
})
export class ModalDossierEquipement implements OnInit {
    @Input() idDossierIntervention: number;
    @Input() pieceEquipement: PieceEquipement = new PieceEquipement();

    success: boolean = false;
    error: boolean = false;
    equipements: Array<Equipement> = [];
    pieces: Array<Piece> = [];
    techniciens: Array<User> = [];
    equipementForm: FormGroup;


    constructor(
        private equipementService: EquipementService,
        private dossierInterventionService: DossierInterventionService,
        private userService: UserService,
        public dialogRef: MatDialogRef<ModalDossierEquipement>,
    ) {
    }

    ngOnInit(): void {
        this.equipementForm = new FormGroup({
            id: new FormControl(this.pieceEquipement.id),
            equipement_id: new FormControl(this.pieceEquipement.equipement_id, [Validators.required]),
            piece_id: new FormControl(this.pieceEquipement.piece_id, [Validators.required]),
            date_installation: new FormControl(this.pieceEquipement.date_installation, [Validators.required]),
            heuredh: new FormControl(null),
            date_recuperation: new FormControl(this.pieceEquipement.date_recuperation),
            user_id: new FormControl(this.pieceEquipement.user_id)
        });

        this.fetchAll();
    }

    fetchAll(): void {
        this.fetchEquipements();
        this.fetchPieces();
        this.fetchTechnicients();
    }

    fetchEquipements(): void {
        this.equipementService.getEquipements().subscribe((equipements) => {
            this.equipements = equipements;
        });
    }

    fetchPieces(): void {
        this.dossierInterventionService.getPiecesForDossierIntervention(this.idDossierIntervention).subscribe((pieces) => {
            this.pieces = pieces;
        });
    }

    fetchTechnicients(): void {
        this.userService.getUsers().subscribe((techniciens) => {
            this.techniciens = techniciens;
        });
    }

    onFormSubmit(): void {
        this.error = false;
        this.success = false;
        this.equipementForm.markAllAsTouched();

        if (this.equipementForm.valid) {
          const pieceEquipement = new PieceEquipement(this.equipementForm.value);

          if (pieceEquipement.id === null) {
              this.dossierInterventionService.storePieceEquipementForDossierIntervention(this.idDossierIntervention, pieceEquipement).subscribe(
                  (response) => {
                      this.success = true;
                      this.dialogRef.close(response);
                  }, (error) => { this.error = true; }
              );
          } else {
              this.dossierInterventionService.updatePieceEquipementForDossierIntervention(this.idDossierIntervention, pieceEquipement).subscribe(
                  (response) => {
                      this.success = true;
                      this.dialogRef.close(response);
                  }, (error) => { this.error = true; }
              );
          }

        }
    }
}
